import axios from 'axios';

export const FETCH_DRAFTSORGANISATION_BEGIN = 'FETCH_DRAFTSORGANISATION_BEGIN';
export const FETCH_DRAFTSORGANISATION_SUCCESS = 'FETCH_DRAFTSORGANISATION_SUCCESS';
export const FETCH_DRAFTSORGANISATION_FAILURE = 'FETCH_DRAFTSORGANISATION_FAILURE';


export const fetchDraftsOrganisationBegin = () => ({
    type: FETCH_DRAFTSORGANISATION_BEGIN
});

export const fetchDraftsOrganisationSuccess = DraftsOrganisation => ({
    type: FETCH_DRAFTSORGANISATION_SUCCESS,
    payload: DraftsOrganisation
});

export const fetchDraftsOrganisationFailure = error => ({
    type: FETCH_DRAFTSORGANISATION_FAILURE,
    payload: { error }
});

export const getDraftsOrganisation = (aemurl, organisationId) => {
   
    return dispatch => {
        dispatch(fetchDraftsOrganisationBegin());

        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            withCredentials: true
        };

        return axios.get(aemurl + "?formType=RPAREGO&organisationId=" + organisationId, null, options) //should be in parameters?
            .then(responseArr => {
                return dispatch(fetchDraftsOrganisationSuccess(responseArr.data)); 
            })
            .catch(error => {
                if (window.location.origin === "https://localhost:44336") {
                    return dispatch(fetchDraftsOrganisationSuccess([]));
                }
                if (error.response) {
                    if (error.response.status === 200) {
                        return dispatch(fetchDraftsOrganisationFailure("System error DRO.1a: " + error.request.statusText));
                    }
                    else {
                        if (error.response.data !== "") {
                            return dispatch(fetchDraftsOrganisationFailure("System error DRO.1e: " + error.response.data.errors[0]));
                        }
                        return dispatch(fetchDraftsOrganisationFailure("System error DRO.1d: " + error.request.statusText));
                    }
                } else if (error.request) {
                    return dispatch(fetchDraftsOrganisationFailure("System error DRO.1b: " + error.request.statusText));
                } else {
                    return dispatch(fetchDraftsOrganisationFailure("System error DRO.1c: " + error));
                }
            });
       
      
    };
}

